import React, { Component } from "react";
import Time from "react-time-format";
import Swal from "sweetalert2";
import { Button, Input, Popover } from "antd";
import { FaInfoCircle } from "react-icons/fa";
class ViewScurity extends Component {
 constructor(props) {
  super(props);
  this.state = {
   tenantphone: "",
   ownerPhone: "",
   tenantname: "",
   ownername: "",
   alley: "",
   tenantadress: "",
   NoOfPropert: "",
   ownerSeating: "",
   scuertyName: "",
   tenant_nationality: "",
   save: null,
   // old tenant
   oldtenantphone: "",
   oldtenantadress: "",
   oldtenantname: "",
   oldtenant_nationality: "",
   redirect: false,
   familynumber: "",
   scuretyCode: "",
   scuretyCodeTenant: "",
  };
 }
 componentDidUpdate(prevProps) {
  if (prevProps.scurety_view_obj !== this.props.scurety_view_obj) {
   this.setState({
    tenantphone: this.props.scurety_view_obj.tenantphone,
    ownerPhone: this.props.scurety_view_obj.ownerPhone,
    tenantname: this.props.scurety_view_obj.tenantname,
    ownername: this.props.scurety_view_obj.ownername,
    alley: this.props.scurety_view_obj.alley,
    tenantadress: this.props.scurety_view_obj.tenantadress,
    NoOfPropert: this.props.scurety_view_obj.NoOfPropert,
    ownerSeating: this.props.scurety_view_obj.ownerSeating,
    scuertyName: this.props.scurety_view_obj.scuertyName,
    updated: true,
    tenant_nationality: this.props.scurety_view_obj.tenant_nationality,
    oldtenantphone: this.props.scurety_view_obj.oldtenantphone,
    oldtenantadress: this.props.scurety_view_obj.oldtenantadress,
    oldtenantname: this.props.scurety_view_obj.oldtenantname,
    oldtenant_nationality: this.props.scurety_view_obj.oldtenant_nationality,
    familynumber: this.props.scurety_view_obj.familynumber,
    scuretyCode: this.props.scurety_view_obj.scuretyCode,
    scuretyCodeTenant: this.props.scurety_view_obj.scuretyCodeTenant,
   });
  }
 }
 handleChange = (e) => {
  this.setState({
   [e.target.name]: e.target.value,
  });
 };

 onOpenUpdate = async () => {
  this.setState({ updated: false });
 };
 onCloseUpdate = () => {
  const { handleCancel } = this.props;
  const data = {
   tenantphone: this.state.tenantphone,
   ownerPhone: this.state.ownerPhone,
   tenantname: this.state.tenantname,
   ownername: this.state.ownername,
   alley: this.state.alley,
   tenantadress: this.state.tenantadress,
   NoOfPropert: this.state.NoOfPropert,
   ownerSeating: this.state.ownerSeating,
   scuertyName: this.state.scuertyName,
   oldtenant_nationality: this.state.oldtenant_nationality,
   tenant_nationality: this.state.tenant_nationality,
   oldtenantphone: this.state.oldtenantphone,
   oldtenantadress: this.state.oldtenantadress,
   oldtenantname: this.state.oldtenantname,
   familynumber: this.state.familynumber,
   scuretyCode: this.state.scuretyCode,
   scuretyCodeTenant: this.state.scuretyCodeTenant,
  };
  if (
   this.state.ownername === "" ||
   this.state.ownerPhone === "" ||
   this.state.ownerPhone === 0 ||
   this.state.tenantname === "" ||
   this.state.ownername === "" ||
   this.state.scuertyName === ""
  ) {
   Swal.fire({
    title: "OPS",
    text: this.props.change_Lang("Please Check Inputs"),
    icon: "error",
    html: `<b class="fk">${this.props.change_Lang("Please Check Inputs")}</b>`,
    confirmButtonText: this.props.change_Lang("Ok"),
    buttonsStyling: { fontFamily: "fk" },
    timer: 1300,
   });
  } else {
   Swal.fire({
    title: "Good job!",
    html: `<b class="fk">${this.props.change_Lang(
     "You successfully tainted your work"
    )}</b>`,
    icon: "success",
    confirmButtonText: this.props.change_Lang("success"),
    buttonsStyling: { fontFamily: "fk" },
    timer: 1000,
   });
   this.props.Update_ScuretyBill(this.props.scurety_view_obj._id, data);
   handleCancel();
   this.setState({ updated: true, redirect: true });
  }
 };
 Asaysh_getPrint = () => {
  window.setTimeout("window.print()", 4000);
 };
 render() {
  const { lang, change_Lang, user } = this.props;
  const { handleChange, onCloseUpdate, onOpenUpdate } = this;
  const {
   tenantphone,
   ownerPhone,
   tenantname,
   ownername,
   tenantadress,
   NoOfPropert,
   ownerSeating,
   scuertyName,
   oldtenant_nationality,
   tenant_nationality,
   scuretyCode,
   scuretyCodeTenant,
   updated,
  } = this.state;
  return (
   <>
    <div
     className={`${lang === "en" ? "container-fluid" : "container-fluid fk"}`}
    >
     <p
      style={{
       fontSize: "20px",
       color: "black",
       background: "white",
      }}
      className="mb-4 d-lg-none d-sm-flex justify-content-sm-start text-center text-uppercase p-1"
     >
      {change_Lang("Sceurity Anket")}
     </p>
     <div className="row">
      <div className="col-12">
       <div className="row">
        <div className="col-md-1 text-right ">
         <p
          style={{
           fontSize: "18px",
           color: "#022859",
           fontWeight: "bold",
          }}
          className="mb-1 d-flex justify-content-start"
         >
          {change_Lang("to")}:
         </p>
        </div>
        <div className="col-md-3 text-right ">
         <Input
          type="text"
          className={`${
           lang === "en"
            ? "form-control text-center"
            : "form-control text-center fk"
          }`}
          value={scuertyName}
          name="scuertyName"
          size="middle"
          readOnly={updated !== false ? true : false}
          onChange={handleChange}
          autoComplete="off"
          addonBefore={
           <>
            <Popover
             content={
              <div className="text-center">
               <span className="fk" style={{ fontSize: "14px" }}>
                {"ئایا ئە ئەنکێتە بۆ ئاسایشە یاخود بۆ پڕۆژەیە داخڵ بکە"}
               </span>
               <br />
               <span className="text-center">نمونە : ئاسایشی ______</span>
              </div>
             }
            >
             <span className=" py-0 px-0">
              <i className="fas fa-info-circle"></i>
             </span>
            </Popover>
           </>
          }
         />
        </div>
        <div className="col-sm-4"></div>
        <div className="col-sm-1">
         <p
          style={{
           fontSize: "18px",
           color: "#022859",
           fontWeight: "bold",
          }}
          className="mb-1 d-flex justify-content-start"
         >
          {change_Lang("date")}:
         </p>
        </div>
        <div className="col-sm-3">
         <Time
          value={Date.now()}
          format="YYYY-MM-DD"
          className={`${
           lang === "en"
            ? "form-control text-center"
            : "form-control text-center fk"
          }`}
          style={{
           fontSize: "18px",
           color: "blck",
          }}
          // className="form-control col-sm-12 text-center py-0"
         />
        </div>
       </div>
       <br />
       <div className="row">
        <div className="col-md-12">
         <p
          style={{
           fontSize: "20px",
           color: "black",
           background: "white",
           borderRadius: "10px",
          }}
          className="mb-4 d-none d-lg-flex justify-content-center text-uppercase p-1"
         >
          {change_Lang("Sceurity Anket")}
         </p>
        </div>
       </div>
       <div className="row d-flex justify-content-center">
        <div className="form-group input-container col-md-3">
         <label
          className="col-form-label fk d-flex justify-content-center"
          style={{
           fontSize: "16px",
           color: "#052f43",
           fontWeight: "bold",
          }}
         >
          <span style={{ color: "#052f43" }}>*</span>
          &nbsp; ناوی کرێچی ئێستا
         </label>
         <Input
          size="middle"
          value={tenantname}
          readOnly={updated !== false ? true : false}
          name="tenantname"
          onChange={handleChange}
          type="text"
          style={{
           fontSize: "16px",
           borderBottomColor: "#052f43",
          }}
          addonBefore={
           <>
            <Popover
             content={
              <div className="text-center">
               <span className="fk" style={{ fontSize: "14px" }}>
                {"ناوی کرێچی ئێستا کە موڵکەکەی بە کرێگرتووە داخڵ بکە"}
               </span>
               <br />
               <span className="text-center">نمونە : محمد عبداللە عمر</span>
              </div>
             }
            >
             <span className=" py-0 px-0">
              <i className="fas fa-info-circle"></i>
             </span>
            </Popover>
           </>
          }
         />
        </div>

        <div className="form-group input-container col-md-3">
         <label
          className="col-form-label fk d-flex justify-content-center"
          style={{
           fontSize: "16px",
           color: "#052f43",
           fontWeight: "bold",
          }}
         >
          <span style={{ color: "#052f43" }}>*</span>
          &nbsp; شوێنی هاتنی
         </label>
         <Input
          size="middle"
          value={tenantadress}
          name="tenantadress"
          readOnly={updated !== false ? true : false}
          onChange={handleChange}
          type="text"
          style={{
           fontSize: "16px",
           borderBottomColor: "#052f43",
          }}
          addonBefore={
           <>
            <Popover
             content={
              <div className="text-center">
               <span className="fk" style={{ fontSize: "14px" }}>
                {"شوێنی هاتنی کرێچی ئێستا داخڵ بکە"}
               </span>
               <br />
               <span className="text-center">نمونە : ستار تاوەر</span>
              </div>
             }
            >
             <span className=" py-0 px-0">
              <i className="fas fa-info-circle"></i>
             </span>
            </Popover>
           </>
          }
         />
        </div>

        <div className="form-group input-container col-md-3">
         <label
          className="col-form-label fk d-flex justify-content-center"
          style={{
           fontSize: "16px",
           color: "#052f43",
           fontWeight: "bold",
          }}
         >
          <span style={{ color: "#052f43" }}>*</span>
          &nbsp; نەتەوە
         </label>
         <Input
          size="middle"
          value={tenant_nationality}
          readOnly={updated !== false ? true : false}
          name="tenant_nationality"
          onChange={handleChange}
          type="text"
          style={{
           fontSize: "16px",
           borderBottomColor: "#052f43",
          }}
          addonBefore={
           <>
            <Popover
             content={
              <div className="text-center">
               <span className="fk" style={{ fontSize: "14px" }}>
                {"نەتەوەی کرێچی ئێستا داخڵ بکە"}
               </span>
               <br />
               <span className="text-center">نمونە : کورد</span>
              </div>
             }
            >
             <span className=" py-0 px-0">
              <i className="fas fa-info-circle"></i>
             </span>
            </Popover>
           </>
          }
         />
        </div>

        <div className="form-group input-container col-md-3">
         <label
          className="col-form-label fk d-flex justify-content-center"
          style={{
           fontSize: "16px",
           color: "#052f43",
           fontWeight: "bold",
          }}
         >
          <span style={{ color: "#052f43" }}>*</span>
          &nbsp;
          {change_Lang("invoice_mob")}
         </label>
         <Input
          size="middle"
          value={tenantphone}
          name="tenantphone"
          onChange={handleChange}
          readOnly={updated !== false ? true : false}
          type="number"
          style={{
           fontSize: "16px",
           borderBottomColor: "#052f43",
          }}
          addonBefore={
           <>
            <Popover
             content={
              <div className="text-center">
               <span className="fk" style={{ fontSize: "14px" }}>
                {"ژمارەی مۆبایلی کرێچی ئێستا داخڵ بکە تەنها ژمارەی ئینگلیزی"}
               </span>
               <br />
               <span className="text-center">نمونە : 075075075075</span>
              </div>
             }
            >
             <span className=" py-0 px-0">
              <i className="fas fa-info-circle"></i>
             </span>
            </Popover>
           </>
          }
         />
        </div>
        {/* <div className="form-group input-container col-md-2">
                  <label
                    className="col-form-label fk d-flex justify-content-center"
                    style={{
                      fontSize: "16px",
                      color: "#052f43",
                      fontWeight: "bold",
                    }}
                  >
                    <span style={{ color: "#052f43" }}>*</span>
                    &nbsp; ژ. ئەندامانی خێزان
                  </label>
                  <Input
                    size="middle"
                    value={familynumber}
                    name="familynumber"
                    onChange={handleChange}
                    readOnly={updated !== false ? true : false}
                    type="number"
                    style={{
                      fontSize: "16px",
                      borderBottomColor: "#052f43",
                    }}
                    addonBefore={
                      <>
                        <Popover
                          content={
                            <div className="text-center">
                              <span className="fk" style={{ fontSize: "14px" }}>
                                {
                                  "ژمارەی ئەندامەکانی کرێچی ئێستا داخڵ بکە تەنها ژمارەی ئینگلیزی"
                                }
                              </span>
                              <br />
                              <span className="text-center">نمونە : 5</span>
                            </div>
                          }
                        >
                          <span className=" py-0 px-0">
                            <i className="fas fa-info-circle"></i>
                          </span>
                        </Popover>
                      </>
                    }
                  />
                </div> */}
       </div>
       <div className="row d-flex justify-content-center">
        <div className="form-group input-container col-md-3">
         <label
          className="col-form-label fk d-flex justify-content-center"
          style={{
           fontSize: "16px",
           color: "#052f43",
           fontWeight: "bold",
          }}
         >
          <span style={{ color: "#052f43" }}>*</span>
          &nbsp; ناوی خاوەن موڵك
         </label>
         <Input
          size="middle"
          value={ownername}
          name="ownername"
          readOnly={updated !== false ? true : false}
          onChange={handleChange}
          type="text"
          style={{
           fontSize: "16px",
           borderBottomColor: "#052f43",
          }}
          addonBefore={
           <>
            <Popover
             content={
              <div className="text-center">
               <span className="fk" style={{ fontSize: "14px" }}>
                {"ناوی خاوەن موڵک داخڵ بکە بەم شێوەیە"}
               </span>
               <br />
               <span className="text-center">نمونە : محمد عبداللە عمر</span>
              </div>
             }
            >
             <span className=" py-0 px-0">
              <i className="fas fa-info-circle"></i>
             </span>
            </Popover>
           </>
          }
         />
        </div>

        <div className="form-group input-container col-md-3">
         <label
          className="col-form-label fk d-flex justify-content-center"
          style={{
           fontSize: "16px",
           color: "#052f43",
           fontWeight: "bold",
          }}
         >
          <span style={{ color: "#052f43" }}>*</span>
          &nbsp; ناونیشانی موڵك
         </label>
         <Input
          size="middle"
          value={ownerSeating}
          name="ownerSeating"
          readOnly={updated !== false ? true : false}
          onChange={handleChange}
          type="text"
          style={{
           fontSize: "16px",
           borderBottomColor: "#052f43",
          }}
          addonBefore={
           <>
            <Popover
             content={
              <div className="text-center">
               <span className="fk" style={{ fontSize: "14px" }}>
                {"ناونیشانی موڵکەکە داخڵ بکە"}
               </span>
               <br />
               <span className="text-center">نمونە : ستار تاوەر</span>
              </div>
             }
            >
             <span className=" py-0 px-0">
              <i className="fas fa-info-circle"></i>
             </span>
            </Popover>
           </>
          }
         />
        </div>

        <div className="form-group input-container col-md-3">
         <label
          className="col-form-label fk d-flex justify-content-center"
          style={{
           fontSize: "16px",
           color: "#052f43",
           fontWeight: "bold",
          }}
         >
          <span style={{ color: "#052f43" }}>*</span>
          &nbsp; ژمارەی موڵک
         </label>
         <Input
          size="middle"
          value={NoOfPropert}
          readOnly={updated !== false ? true : false}
          name="NoOfPropert"
          onChange={handleChange}
          type="text"
          style={{
           fontSize: "16px",
           borderBottomColor: "#052f43",
          }}
          addonBefore={
           <>
            <Popover
             content={
              <div className="text-center">
               <span className="fk" style={{ fontSize: "14px" }}>
                {"ژمارەی کارەبای موڵك یاخود ژمارەی موڵکەکە داخڵ بکە"}
               </span>
               <br />
               <span className="text-center">نمونە : 45/12/25</span>
              </div>
             }
            >
             <span className=" py-0 px-0">
              <i className="fas fa-info-circle"></i>
             </span>
            </Popover>
           </>
          }
         />
        </div>

        <div className="form-group input-container col-md-3">
         <label
          className="col-form-label fk d-flex justify-content-center"
          style={{
           fontSize: "16px",
           color: "#052f43",
           fontWeight: "bold",
          }}
         >
          <span style={{ color: "#052f43" }}>*</span>
          &nbsp;
          {change_Lang("invoice_mob")}
         </label>
         <Input
          size="middle"
          value={ownerPhone}
          readOnly={updated !== false ? true : false}
          name="ownerPhone"
          onChange={handleChange}
          type="number"
          style={{
           fontSize: "16px",
           borderBottomColor: "#052f43",
          }}
          addonBefore={
           <>
            <Popover
             content={
              <div className="text-center">
               <span className="fk" style={{ fontSize: "14px" }}>
                {
                 "ژمارەی مۆبایلی خاوەن موڵک داخڵ بکە تەنها ژمارەی ئینگلیزی داخڵ بکە"
                }
               </span>
               <br />
               <span className="text-center">نمونە : 075075075075</span>
              </div>
             }
            >
             <span className=" py-0 px-0">
              <i className="fas fa-info-circle"></i>
             </span>
            </Popover>
           </>
          }
         />
        </div>
        <div className="form-group input-container col-md-4">
         <label
          className="col-form-label fk d-flex justify-content-center"
          style={{
           fontSize: "16px",
           color: "#000",
           fontWeight: "bold",
          }}
         >
          <span style={{ color: "#000" }}>*</span>
          &nbsp; کۆدی ئاسایش (خاوەن موڵک)
         </label>
         <Input
          size="middle"
          value={scuretyCode}
          name="scuretyCode"
          readOnly={updated !== false ? true : false}
          onChange={handleChange}
          type="text"
          style={{
           fontSize: "16px",
           borderBottomColor: "#000",
          }}
          addonBefore={
           <>
            <Popover
             content={
              <div className="text-center">
               <span className="fk" style={{ fontSize: "14px" }}>
                {"کۆدی ئاسایش داخڵ بکە"}
               </span>
               <br />
               <span className="text-center">نمونە : 5454</span>
              </div>
             }
            >
             <FaInfoCircle
              style={{
               justifyContent: "center",
               alignItems: "center",
               display: "flex",
               color: "#000",
               fontWeight: "bolder",
              }}
              size={15}
             />
            </Popover>
           </>
          }
         />
        </div>
        <div className="form-group input-container col-md-4">
         <label
          className="col-form-label fk d-flex justify-content-center"
          style={{
           fontSize: "16px",
           color: "#000",
           fontWeight: "bold",
          }}
         >
          <span style={{ color: "#000" }}>*</span>
          &nbsp; کۆدی ئاسایش (کرێچی)
         </label>
         <Input
          size="middle"
          value={scuretyCodeTenant}
          name="scuretyCodeTenant"
          readOnly={updated !== false ? true : false}
          onChange={handleChange}
          type="text"
          style={{
           fontSize: "16px",
           borderBottomColor: "#000",
          }}
          addonBefore={
           <>
            <Popover
             content={
              <div className="text-center">
               <span className="fk" style={{ fontSize: "14px" }}>
                {"کۆدی ئاسایشی کرێچی"}
               </span>
               <br />
               <span className="text-center">نمونە : 5454</span>
              </div>
             }
            >
             <FaInfoCircle
              style={{
               justifyContent: "center",
               alignItems: "center",
               display: "flex",
               color: "#000",
               fontWeight: "bolder",
              }}
              size={15}
             />
            </Popover>
           </>
          }
         />
        </div>
       </div>

       <br />
       {user && user.u_scurety !== false ? (
        <div className="row">
         <div className="col-12 d-flex justify-content-center">
          {updated !== false ? (
           <Button
            className="ml-4 fk px-4"
            type="primary"
            shape="round"
            style={{
             background: "#d7e4eb",
             color: "#4b85a4",
             border: "none",
             outline: "none",
            }}
            htmlType="submit"
            onClick={onOpenUpdate}
           >
            {change_Lang("profile_updatebt")}&nbsp;
            <i className="fa fa-lock" style={{ fontSize: "14px" }}></i>
           </Button>
          ) : (
           <Button
            className="ml-4 fk px-4"
            type="primary"
            shape="round"
            style={{
             background: "#d7e4eb",
             color: "#4b85a4",
             border: "none",
             outline: "none",
            }}
            htmlType="submit"
            onClick={onCloseUpdate}
           >
            {change_Lang("profile_updatebt")}&nbsp;
            <i className="fa fa-lock-open" style={{ fontSize: "14px" }}></i>
           </Button>
          )}{" "}
         </div>
        </div>
       ) : (
        ""
       )}
      </div>
     </div>
    </div>
   </>
  );
 }
}

export default ViewScurity;
